<template>
  <div>
    <div v-if="isLoading">
      <v-progress-linear indeterminate color="primary"></v-progress-linear>
    </div>
    <v-container fluid>
      <v-row dense>
        <v-col cols="12" md="6">
          <v-text-field
            solo
            hide-details
            clearable
            label="Search for title or body"
            append-icon="mdi-magnify"
            v-model="query.search"
            v-on:clear="clearSearch"
            v-on:click:append="onRequestSearch"
            v-on:keydown.enter="onRequestSearch"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6">
          <v-text-field
            label="Select publish date"
            solo
            clearable
            hide-details
            readonly
            v-model="formattedDate"
            @click:clear="dateClearCallback"
            prepend-icon="mdi-calendar"
            @click="showDatePickerDialog = true"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field
            clearable
            solo
            append-icon="mdi-magnify"
            label="Search by tag"
            v-model="query.search_tag"
            v-on:click:append="requestTagSearch"
            v-on:keydown.enter="requestTagSearch"
            v-on:click:clear="clearTagSearch"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>
    <v-pagination
      v-if="this.pagination != undefined && this.pagination.totalItems > 0"
      v-model="pagination.currentPage"
      v-bind:length="pagination.pageCount"
      v-on:input="onRequestPageChange"
      circle
    ></v-pagination>
    <div v-if="!isLoading">
      <v-row class="ma-1">
        <v-col v-if="news !== null && news.length <= 0">
          <v-banner single-line class="text-h6">
            No records
          </v-banner>
        </v-col>
        <v-col
          sm="12"
          md="6"
          v-for="item in news"
          :key="item.id"
          class="d-flex child-flex"
        >
          <breaking-news
            :post="item"
            @priorityChanged="priorityChangeCallback"
            @deleted="deleteSuccessCallback"
            :showPriorityField="showPriorityOrderField"
          />
        </v-col>
      </v-row>
    </div>
    <DatePickerDialog
      @dateSelected="dateSelectionCallback"
      :visible="showDatePickerDialog"
      @close="showDatePickerDialog = false"
    ></DatePickerDialog>
  </div>
</template>

<script>
import bNApi from '@/api/breakingNewsApi'
// import snackbar from '@/utils/snackbar'
import DatePickerDialog from '@/components/DatePickerDialog'
import dateUtils from '@/utils/dateUtils'
import * as dateFormats from '@/constants/dateFormats'

export default {
  components: {
    DatePickerDialog,
    'breaking-news': () => import('@/components/BreakingNewsCard')
  },
  mounted () {
    // When returning from add/edit breaking news. check for date
    if (window.publish_date) {
      this.query.publish_date = window.publish_date
      window.publish_date = null
      this.formattedDate = this.$moment(this.query.publish_date).format(
        dateFormats.DDMMYY
      )
    }
    this.fetchBreakingNews()
  },

  data: function () {
    return {
      showDatePickerDialog: false,
      formattedDate: null,
      isValid: null,
      imageData: '',
      search: null,
      showPriorityOrderField: false,
      query: {
        search: null,
        sort: null,
        page: 1,
        item_per_page: 16,
        publish_date: null
      },
      searchLabel: 'Search for title or body',
      validation: {
        title: [v => !!v || 'Please enter title']
      },
      pagination: {
        currentPage: 1,
        pageItemFrom: 0,
        pageItemTo: 0,
        totalItems: 0,
        pageCount: 0
      },
      news: [],
      isLoading: false
    }
  },
  methods: {
    clearTagSearch () {
      this.query.search = null
      this.fetchBreakingNews()
    },
    requestTagSearch () {
      this.fetchBreakingNews()
    },
    priorityChangeCallback () {
      this.fetchBreakingNews()
    },
    dateSelectionCallback (data) {
      this.$log.info('date selection callback', [data])
      this.formattedDate = data
      this.query.publish_date = dateUtils.parseDate(data)
      this.togglePriorityField()
      this.fetchBreakingNews()
    },
    dateClearCallback () {
      this.$log.info('date clear callback')
      this.query.publish_date = null
      this.togglePriorityField()
      this.fetchBreakingNews()
    },
    deleteSuccessCallback () {
      this.fetchBreakingNews()
    },
    async fetchBreakingNews () {
      try {
        this.isLoading = true
        const response = await bNApi.index(this.query)
        this.parsePaginationData(response.data)
        this.news = response.data.data
      } finally {
        this.isLoading = false
      }
    },
    onRequestSort () {
      this.fetchBreakingNews()
    },
    onRequestSearch () {
      this.fetchBreakingNews()
    },
    clearSearch () {
      this.query.search = null
      this.fetchBreakingNews()
    },
    togglePriorityField () {
      this.$log.info('togglel priority field', [this.query.publish_date])
      if (this.query.publish_date !== null) {
        this.showPriorityOrderField = true
        this.query.sort = 'order:asc'
      } else {
        this.showPriorityOrderField = false
        this.query.sort = 'publish_date:desc'
      }
    },
    parsePaginationData (pagination) {
      this.pagination.currentPage = pagination.current_page
      this.pagination.totalItems = pagination.total
      this.pagination.pageItemFrom = pagination.from
      this.pagination.pageItemTo = pagination.to
      this.pagination.pageCount = pagination.last_page
    },
    onRequestPageChange (pageNo) {
      this.query.page = pageNo
      this.fetchBreakingNews()
    }
  }
}
</script>
